<template>
  <!-- 活动申请列表页面 -->
  <div class="page-container">
    <div class="page-card">
      <!-- 页面头部 -->
      <div class="page-card__header">
        <span style="padding-right: 20px">活动申请列表</span>
      </div>
      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="title" label="活动名称"> </el-table-column>
          <el-table-column prop="desc" label="申请描述"> </el-table-column>
          <el-table-column prop="linkman" label="联系人" width="100"> </el-table-column>
          <el-table-column prop="phone" label="手机号" width="120"> </el-table-column>
          <el-table-column prop="start_time" label="活动开始时间" width="150">
          </el-table-column>
          <el-table-column prop="end_time" label="活动结束时间" width="150"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn--danger"
                @click="deleteClick(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <div style="margin: 20px 0; padding: 20px 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "reserveList",
  data() {
    return {
      tableData: [],
      // 分页相关数据
      aSum: 0,
      currentPage: 1,
      pageCount: 1,
      pagesize: 10,
    };
  },
  mounted() {
    // 初始化加载数据
    this.datalist();
  },

  methods: {
    // 获取活动申请列表数据
    datalist() {
      let url = this.baseUrl + "/admin/activity_applys/?ordering=-create_time";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换处理
    handleCurrentChange(val) {
      let url =
        this.baseUrl + "/admin/activity_applys/?ordering=-create_time&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 删除活动申请
    deleteClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/activity_applys/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.datalist();
        });
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/activityApply.vue